import { useEffect } from "react";
import { Label } from "@/components/atoms/texts/label";
import PrintErrorMessage from "@/components/organisms/feedback/PrintErrorMessage";
import { useConsultantInvoice } from "@/services/global-services/query/useConsultantInvoice";
import { useCompanyBenefitInvoice } from "@/services/global-services/query/useCompanyBenefitInvoice";
import { useCooptationPayment } from "@/services/global-services/query/useCooptationPayment";
import { useExpenseReport } from "@/services/global-services/query/useExpenseReport";
import { usePayslip } from "@/services/global-services/query/usePayslip";
import Payslip from "@/components/macro-organisms/tabs/consultants-vision-admin/payslib/payslip";
import Invoice from "@/components/macro-organisms/tabs/consultants-vision-admin/statement/Invoice";
import CompanyBenefits from "@/components/macro-organisms/tabs/consultant-vision-user/companyBenefit/CompanyBenefits";
import Expense from "@/components/macro-organisms/tabs/consultant-vision-user/expense-account/expense";
import Cooptation from "@/components/macro-organisms/tabs/consultants-vision-admin/cooptation/Cooptation";
// Remplacer par le bon chemin si besoin
// import Expense from "@/components/macro-organisms/tabs/consultants-vision-admin/expense/Expense";

export default function DetailsAboutOverflowOperation({ type, uuid, isAdmin = false, className }) {
    // Initialisation des hooks
    const consultantInvoiceHook = useConsultantInvoice();
    const companyBenefitInvoiceHook = useCompanyBenefitInvoice();
    const cooptationPaymentHook = useCooptationPayment();
    const expenseReportHook = useExpenseReport();
    const payslipHook = usePayslip();

    const hookMap = {
        CONSULTANT_INVOICE: {
            hook: consultantInvoiceHook,
            getter: consultantInvoiceHook.getConsultantInvoice,
            Component: Invoice,
            dataOwner: isAdmin
        },
        COMPANY_BENEFIT_INVOICE: {
            hook: companyBenefitInvoiceHook,
            getter: companyBenefitInvoiceHook.getCompanyBenefitInvoice,
            Component: CompanyBenefits,
            dataOwner: isAdmin

        },
        COOPTATION: {
            hook: cooptationPaymentHook,
            getter: cooptationPaymentHook.getCooptationPayment,
            Component: Cooptation,
            dataOwner: isAdmin

        },
        EXPENSE_REPORT: {
            hook: expenseReportHook,
            getter: expenseReportHook.getExpenseReport,
            Component: Expense,
            dataOwner: !isAdmin

        },
        PAYSLIP: {
            hook: payslipHook,
            getter: payslipHook.getPayslip,
            Component: Payslip,
            dataOwner: isAdmin

        },
    };
    console.log('details about operation isAdmin', isAdmin, "dataowner", hookMap[type]?.dataOwner);

    useEffect(() => {
        if (uuid && hookMap[type]) {
            hookMap[type].getter(uuid);
        }
        // eslint-disable-next-line
    }, [type, uuid]);

    const selectedHook = hookMap[type]?.hook;
    const SelectedComponent = hookMap[type]?.Component;
    const selectedDataOwner = hookMap[type]?.dataOwner; // Ajout pour récupérer la bonne valeur
    const hideControls = ["PAYSLIP", "EXPENSE_REPORT", "COMPANY_BENEFIT_INVOICE", "CONSULTANT_INVOICE", "COOPTATION"].includes(type);

    return (
        <div className={`flex flex-col gap-secondDegree items-center justify-center  w-full h-full rounded-sm ${className}`}>
            <Label fontWeight="semibold" message={`consultants.statement.statementOperations.statementOperationType_${type}`}></Label>
            {/* <Label fontWeight="semibold">UUID : {uuid}</Label> */}
            {selectedHook && (
                <>
                    {selectedHook.loading && <span className="loader" />}
                    {selectedHook.error && <PrintErrorMessage error={selectedHook.error} />}
                    {selectedHook.data && SelectedComponent ? (
                        <SelectedComponent data={selectedHook.data} dataOwner={selectedDataOwner} verticalView hideControls={hideControls} />
                    ) : selectedHook.data ? (
                        <pre className="text-xs  rounded p-2 w-full overflow-auto">
                            {JSON.stringify(selectedHook.data, null, 2)}
                        </pre>
                    ) : null}
                </>
            )}
        </div>
    );
}
